export default __webpack_public_path__ + "static/media/mmc-logo-text.0e16a5cc.png";